import React from "react";
import "./JobCards.css";

const JobCardsPresentation = ({ currentJob, nextJob, holeJob, onSchedule }) => (
  <div className="msd-jobs-container">
    {/* Current Job Card */}
    <div className="job-card">
      <div className="job-header">Current Job</div>
      <div className="job-content">
        <div className="job-row status-row">
          <div className="job-status-indicator">
            {/*currentJob?.job_id != null && currentJob?.job_id !== ""*/ onSchedule == 1 ? (
              <>
                <div className="status-circle correct" />
                <div className="status-label correct">On Schedule</div>
              </>
            ) : (
              <>
                <div className="status-circle incorrect" />
                <div className="status-label incorrect">Off Schedule</div>
              </>
            )}
          </div>
        </div>
        <div className="job-row" style={{marginTop:-60}}><span className="job-label">Job Number:</span><span className="job-value">{currentJob?.job_id}</span></div>
        <div className="job-row"><span className="job-label">Step Number:</span><span className="job-value">{currentJob?.StepNo}</span></div>
        <div className="job-row"><span className="job-label">Operator:</span><span className="job-value">{currentJob?.Operator}</span></div>
        <div className="job-row"></div>
        <div className="job-row"><span className="job-label">Start Date:</span><span className="job-value">{currentJob?.aux1data}</span></div>
        <div className="job-row"><span className="job-label">Pcs Run:</span><span className="job-value">{currentJob?.aux2data}</span></div>
        <div className="job-row"><span className="job-label">Quantity Remaining:</span><span className="job-value">{currentJob?.aux3data}</span></div>
        <div className="job-row"><span className="job-label">Quoted Cycle Time:</span><span className="job-value">{currentJob?.aux4data}</span></div>
        <div className="job-row"><span className="job-label">Actual Cycle Time:</span><span className="job-value">{currentJob?.aux5data}</span></div>
      </div>
    </div>

    {/* Next Job Card */}
    <div className="job-card">
      <div className="job-header">Next Job</div>
      <div className="job-content">
        <div className="job-row"><span className="job-label">Job Number:</span><span className="job-value">{currentJob?.aux6data}</span></div>
        <div className="job-row"><span className="job-label">Step Number:</span><span className="job-value">{currentJob?.aux7data}</span></div>
        <div className="job-row"></div>
        <div className="job-row"><span className="job-label">Start Date:</span><span className="job-value">{currentJob?.aux8data}</span></div>
        <div className="job-row"><span className="job-label">Quantity Remaining:</span><span className="job-value">{currentJob?.aux9data}</span></div>
        <div className="job-row"><span className="job-label">Quoted Cycle Time:</span><span className="job-value">{currentJob?.aux10data}</span></div>
      </div>
    </div>

    {/* In the Hole Job Card */}
    <div className="job-card">
      <div className="job-header">"In the Hole" Job</div>
      <div className="job-content">
        <div className="job-row"><span className="job-label">Job Number:</span><span className="job-value">{currentJob?.aux11data}</span></div>
        <div className="job-row"><span className="job-label">Step Number:</span><span className="job-value">{currentJob?.aux12data}</span></div>
        <div className="job-row"></div>
        <div className="job-row"><span className="job-label">Start Date:</span><span className="job-value">{currentJob?.aux13data}</span></div>
        <div className="job-row"><span className="job-label">Quantity Remaining:</span><span className="job-value">{currentJob?.aux14data}</span></div>
        <div className="job-row"><span className="job-label">Quoted Cycle Time:</span><span className="job-value">{currentJob?.aux15data}</span></div>
      </div>
    </div>
  </div>
);

export default JobCardsPresentation; 